import { render, staticRenderFns } from "./p-single-photo-uploader.vue?vue&type=template&id=1da7a37a&"
import script from "./p-single-photo-uploader.vue?vue&type=script&lang=js&"
export * from "./p-single-photo-uploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports